import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import NotificationVuex from '@/store/modules/NotificationVuex'


const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    notification: NotificationVuex,
  }
})

export default store